import '@/modules/card';
import Swiper from 'swiper';
import SwiperCore, { Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Scrollbar]);

export default class FeaturedIconCarousel {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * featured icon carousel element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.pagination = this.sliderElement.querySelector('.swiper-pagination');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        this.init()
    }

    init() {
        new Swiper(this.sliderElement, {
            slidesPerView: 1,
            spaceBetween: 20,
            threshold: 10,
            scrollbar: {
                el: this.scrollbar,
                draggable: true,
                hide: false
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 80
                }
            }
        });
    }
}
